import { DEPARTMENT_LIST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const departmentList = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getDepartmentLists = () => departmentList(
  'get',
  `${DEPARTMENT_LIST}?cb=${Date.now()}`,
);

export const createDepartmentList = (departmentListName) => departmentList(
  'post',
  DEPARTMENT_LIST,
  { department_name: departmentListName },
);

export const updateDepartmentList = (departmentId, departmentListName, isActive) => departmentList(
  'put',
  `${DEPARTMENT_LIST}/${departmentId}`,
  {
    department_name: departmentListName,
    is_active: isActive,
  },
);
